<template>
    <div>
        <v-layout row wrap>
            <v-flex md5>
                <v-select
                    single-line
                    item-value=id
                    item-text=name
                    :items="selecteableActiveBowlers"
                    outline
                    label="Bowler"
                    v-model=form.bowler 
                    @change="onBowlerChange($event)">
                </v-select>
            </v-flex>
        </v-layout>
        <v-container fluid >
                <v-data-table
                        :headers="careerHeaders"
                        :items="careerItems"                      
                        hide-actions
                >
                    <template slot="headers" slot-scope="props">
                    <tr>
                        <th
                            v-for="header in props.headers"
                            :key="header.text">
                            {{ header.text }}
                        </th>
                    </tr>
                    </template>
                    <template slot="items" slot-scope="props">
                        <tr :key="props.index">
                            <td >{{ props.item.high_game }}</td>
                            <td >{{ props.item.high_series }}</td>
                            <td >{{ props.item.average.toFixed(2)  }}</td>
                            <td >{{ props.item.game1.toFixed(2)  }}</td>
                            <td >{{ props.item.game2.toFixed(2)  }}</td>
                            <td >{{ props.item.game3.toFixed(2)  }}</td>
                            <td >{{ props.item.series.toFixed(2)  }}</td>
                            <td >{{ props.item.total_pins }}</td>
                            <!-- <td >{{ props.item.hdcp.toFixed() }}</td> -->
                            <td >{{ props.item.games }}</td>
                            <td >{{ props.item['200+'] + " ("+ props.item['200_percent'].toFixed(2) +')' }}</td>
                            <td >{{ props.item['600+'] + " ("+ props.item['600_percent'].toFixed(2) + ')' }}</td>
                            <td class=small-col>{{props.item.over_average}} </td>
                            <td class=small-col>{{props.item.under_average}} </td>
                            <td >{{props.item.pins_over_under.toFixed(2)}}</td>
                        </tr>
                    </template>
                </v-data-table>
        </v-container>
        <v-container fluid>
            <v-data-table
                    :headers="seasonsHeaders"
                    :items="seasonItems"
                    hide-actions
                    :pagination.sync="seasonPagination"
            >
                <template slot="headers" slot-scope="props">
                <tr>
                    <th
                        v-for="header in props.headers"
                        :key="header.text">
                        {{ header.text }}
                    </th>
                </tr>
                </template>
                <template slot="items" slot-scope="props">
                    <tr :key="props.index">
                        <td >{{ props.item.team }}</td>
                        <td >{{ props.item.high_game }}</td>
                        <td >{{ props.item.high_series }}</td>
                        <td >{{ props.item.average.toFixed(2)  }}</td>
                        <td >{{ props.item.game1.toFixed(2)  }}</td>
                        <td >{{ props.item.game2.toFixed(2)  }}</td>
                        <td >{{ props.item.game3.toFixed(2)  }}</td>
                        <td >{{ props.item.series.toFixed(2)  }}</td>
                        <td >{{ props.item.total_pins }}</td>
                        <td >{{ props.item.hdcp.toFixed(2) }}</td>
                        <td >{{ props.item.games }}</td>
                        <td >{{ props.item['200+'] }}</td>
                        <td >{{ props.item['600+'] }}</td>
                        <td >{{props.item.over_average}} </td>
                        <td >{{props.item.under_average }} </td>
                        <td>{{props.item.pins_over_under.toFixed(2)}}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-container>
        <v-container fluid>
            <v-data-table
                    :headers="headers"
                    :items="items"
                    :rows-per-page-items="[10,25,100, {'text':'All','value':-1}]"
                    :pagination.sync="pagination"
            >
                <template slot="headers" slot-scope="props">
                    <tr>
                        <th
                            v-for="header in props.headers"
                            :key="header.text"
                            :style='{width: header.width}'
                        >
                            {{ header.text }}
                        </th>
                    </tr>
                </template>
                <template slot="items" slot-scope="props">
                    <tr :key="props.index" :class="{ border_bottom:
                    props.item.isLast}">
                        <td >{{ props.item.team_name }}</td>
                        <td >{{ getPrettyDates(props.item.date)
                            }}</td>
                        <td :class="{
                        badScore: (props.item.game1 <= 150),
                        goodScore: (props.item.game1 >= 200)
                        }">
                            {{props.item.game1 }}
                        </td>
                        <td :class="{
                        badScore: (props.item.game2 <= 150),
                        goodScore: (props.item.game2 >= 200)
                        }">
                            {{props.item.game2 }}
                        </td>
                        <td :class="{
                        badScore: (props.item.game3 <= 150),
                        goodScore: (props.item.game3 >= 200)
                        }">
                            {{props.item.game3}}
                        </td>
                        <td :class="{
                        badSeries: (props.item.series <= 500),
                        goodSeries: (props.item.series >= 600)
                        }">
                            {{props.item.series }}
                        </td>
                        <td >{{ props.item.weekly_average.toFixed(2) }}</td>
                        <td >{{props.item.pins_over_under}}</td>
                        <td >{{ props.item.average.toFixed(2)  }}</td>
                        <td >{{ props.item.hdcp.toFixed(2)  }}</td>
                        <td  :class="{
                        badSeries: (props.item.over_average <= 0),
                        goodSeries: (props.item.over_average >= 3)
                        }">
                            {{props.item.over_average }}
                        </td>
                        <td :class="{
                        badSeries: (props.item.under_average >= 3),
                        goodSeries: (props.item.under_average === 0)
                        }">
                            {{props.item.under_average }}
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-container>
    </div>
</template>
<script>
   import axios from "axios"
   export default {
      components: {
      },
      name: 'BowlerHistoryTable',
      data() {
         return {
            form: {
               bowler: null
            },
            pagination : {
               //'sortBy': 'date',
               'sortBy' : 'sortKey',
               'descending': true,
               'rowsPerPage': -1
            },
            seasonPagination : {
               'sortBy': 'team_id',
               'descending': true,
               'rowsPerPage': -1
            },
            careerItems: [],
            items: [],
            seasonItems: []
         }
      },
      computed: {
         selecteableActiveBowlers(){
            return this.$store.getters.activeBowlers.map(this.dbBowlerToFrontendBowler)
         },
         selecteableInactiveBowlers(){
            return this.$store.getters.inactiveBowlers.map(this.dbBowlerToFrontendBowler)
         },
         headers() {
           return [
              { text: 'Team', value: 'team_name', width: "10%" },
              { text: 'Date', value: 'date', width: "10%" },
              { text: 'G1', value: 'game1', width: "5%" },
              { text: 'G2', value: 'game2', width: "5%" },
              { text: 'G3', value: 'game3', width: "5%" },
              { text: 'Series', value: 'series', width: "5%" },
              { text: 'Weekly Avg', value: 'weekly_average', width: "5%" },
              { text: 'Over/Under', value: 'pins_over_under', width: "5%"},
              { text: 'Season Avg', value: 'average', width: "5%" },
              { text: 'Season Hdcp', value: 'hdcp', width: "5%" },
              { text: 'Over', value: 'over_average', width: "1%"},
              { text: 'Games 20+ Under', value: 'under_average', width: "1%"},
              { text: '', value: 'under_average', width: "auto"}
           ]
         },
         seasonsHeaders() {
            return [
               { text:"Team", value: "team"},
               { text:"High Game", value: "high_game"},
               { text:"High Series", value: "high_series"},
               { text:"Avg", value: "average"},
               { text:"G1 Avg", value: "game1"},
               { text:"G2 Avg", value: "game2"},
               { text:"G3 Avg", value: "game3"},
               { text:"Series Avg", value: "series"},
               { text:"Total Pins", value: "total_pins"},
               { text: 'Hdcp', value: 'hdcp' },
               { text:"Games", value: "games"},
               { text:"200+", value: "200+"},
               { text:"600+", value: "600+"},
               { text:"Games Over", value: "over_average"},
               { text:"Games 20+ Under", value: "under_average"},
               { text:"Pins +/- Avg", value: "pins_over_under"}
            ]
         },
         careerHeaders() {
            return [
               { text:"High Game", value: "high_game"},
               { text:"High Series", value: "high_series"},
               { text:"Avg", value: "average"},
               { text:"G1 Avg", value: "game1"},
               { text:"G2 Avg", value: "game2"},
               { text:"G3 Avg", value: "game3"},
               { text:"Series Avg", value: "series"},
               { text:"Total Pins", value: "total_pins"},
               { text:"Games", value: "games"},
               { text:"200+", value: "200+"},
               { text:"600+", value: "600+"},
               { text:"Games Over", value: "over_average"},
               { text:"Games 20+ Under", value: "under_average"},
               { text:"Pins +/- Avg", value: "pins_over_under"}
            ]
         }
      },
      methods:{
         onBowlerChange(value){
            this.$store.state.currentGameEditorSettings.bowler = value
            this.getData(value)
         },
         dbBowlerToFrontendBowler(b){
            return {
               name: b.first_name + " " + b.last_name,
               id: b.id,
               active: b.active,
            }
         },
         sortTableByDate(){
            this.items.sort((a,b) => {
               const aD = new Date(b.date)
               const bD = new Date(a.date)
               return aD>bD ? -1 : aD<bD ? 1 : 0
            })
         },
         sortTableBySortKey(){
            this.items.sort((a,b) => {
               const aD = a.sortKey
               const bD = b.sortKey
               return aD>bD ? -1 : aD<bD ? 1 : 0
            })
         },
         isBadScore(v, n){
            return v <= n
         },
         isGoodScore(v,n ){
            return v >= n
         },
         toggleDialog(){
            this.dialog = !this.dialog
         },
         getSeasonsData: async function(id){
            this.seasonItems = []
            console.log("Getting bowler seasons...")
            const URL = "https://nostyleguy.com/api/bowler_season_summaries/" +
               id.toString()
            await axios({
               method: "GET",
               url: URL
            }).then(
               result => {
                  for(let i in result.data){
                     let bowler = result.data[i]
                     //console.log("Got seassons: " + JSON.stringify(bowler))
                     this.seasonItems.push({
                        team: bowler.team,
                        team_id: bowler.team_id,
                        high_game : bowler.high_game,
                        game1: bowler.game1,
                        game2: bowler.game2,
                        game3: bowler.game3,
                        series: bowler.series,
                        high_series: bowler.high_series,
                        average: bowler.average,
                        hdcp: bowler.hdcp,
                        "200+": bowler["200+"],
                        "600+": bowler["600+"],
                        games: bowler.games,
                        pins_over_under: bowler.pins_over_under,
                        total_pins: bowler.total_pins,
                        over_average: bowler.over_average,
                        under_average: bowler.under_average
                     })
                  }
                 this.seasonItems.sort((a,b) => {
                    const aD = a.high_game
                    const bD = b.high_game
                    return aD>bD ? 1 : aD<bD ? -1 : 0
                 })
               },
               error => {
                  console.log("Error: " + error)
               }
            )
         },
         getCareerData: async function(id){
            this.careerItems = []
            console.log("Getting bowler seasons...")
            const URL = "https://nostyleguy.com/api/bowler_career/" + id.toString()
            await axios({
               method: "GET",
               url: URL
            }).then(
               result => {
                  for(let i in result.data){
                     //let bowler = result.data[i]
                     this.careerItems.push(result.data[i])
                  }
               },
               error => {
                  console.log("Error: " + error)
               }
            )
         },
         getData: async function(id){
            this.getCareerData(id)
            this.getSeasonsData(id)
            this.items = []
            console.log("Getting bowler history...")
            const URL = "https://nostyleguy.com/api/bowler_history/" +
               id.toString()
            await axios({
               method: "GET",
               url: URL
            }).then(
               result => {
                  for(let i in result.data){
                     let bowler = result.data[i]
                     //console.log("Got: " + JSON.stringify(bowler))
                     this.items.push({
                        bowler_name: bowler.bowler,
                        team_name : bowler.team,
                        team_id : bowler.team_id,
                        date: bowler.date,
                        game1: bowler.game1,
                        game2: bowler.game2,
                        game3: bowler.game3,
                        series: bowler.series,
                        pins_over_under: bowler.pins_over_under,
                        weekly_average: bowler.weekly_average,
                        average: bowler.average,
                        hdcp: bowler.hdcp,
                        over_average: bowler.over_average,
                        under_average: bowler.under_average,
                        isLast: false,
                        sortKey: bowler.team_id * 100
                     })
                  }                  

                  this.sortTableByDate()
                  let weekNumPerSeason = {}
                  for(let i in this.items) {
                     let item = this.items[i]
                     if ( item.team_id in weekNumPerSeason ){
                        weekNumPerSeason[item.team_id] += 1;
                        //console.log("Saw team: " + item.team_id + " againt, now: " + weekNumPerSeason[item.team_id])
                     }
                     else {                        
                        weekNumPerSeason[item.team_id] = 0;
                        //console.log("Frist time seeing team: " + item.team_id + " now: " + weekNumPerSeason[item.team_id])
                     }
                     item.sortKey = (item.team_id * 100) + weekNumPerSeason[item.team_id]
                  }
                  console.log("Final: " + JSON.stringify(weekNumPerSeason));

                  this.sortTableBySortKey()
                  for(let i in this.items) {
                     let b = this.items[i]
                     if (this.items[i - 1]) {
                        let b2 = this.items[i - 1]
                        this.items[i].isLast = (b.team_name !==
                           b2.team_name)
                     }
                  }
               },
               error => {
                  console.log("Error: " + error)
               }
            )
            //console.log("Sorting..")
            //this.sortTable()
         },
         getPrettyDates(history){
            let date = new Date(history)
            var monthNames = [
               "January", "February", "March",
               "April", "May", "June", "July",
               "August", "September", "October",
               "November", "December"
            ]

            var day = date.getDate()
            var monthIndex = date.getMonth()
            var year = date.getFullYear()

            return day + ' ' + monthNames[monthIndex].slice(0,3) + ' ' + year
         },
         changeBowler(i){
            console.log("Selected bowler: " + i)
            this.getData(i)
         }
      },
      mounted: function () {
         this.$store.dispatch('getBowlers')
         this.form.bowler = this.$store.state.currentGameEditorSettings.bowler
         if(this.form.bowler != null){
            this.getData(this.form.bowler)
         }
      }
   }
</script>

<style scoped>


table.v-table tbody td:first-child, 
table.v-table tbody td:not(:first-child), 
table.v-table tbody th:first-child, 
table.v-table tbody th:not(:first-child), 
table.v-table thead td:first-child, 
table.v-table thead td:not(:first-child), 
table.v-table thead th:first-child, 
table.v-table thead th:not(:first-child) {
    text-align: center;
}
table.v-table thead th {
    white-space: normal;
    background-color: #548bde;
}
table.v-table tbody td {
    height: 24px;
}
tr.border_bottom td {
    border-top:1pt solid black;
}

td {
    white-space: nowrap;
}

.badScore {
    background-color: #d32d41;
}
.goodScore {
    background-color: #5ed353;
}
.badSeries {
    background-color: #9b2231;
}
.goodSeries {
    background-color: #5d934c;
}
</style>
